// Инициализация всех свайперов на главной странице

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// css импортировать не нужно, он уже в бандле

export function initSwipers(): void {
  // --- START SWIPER ---
  const sliderSelector = "#start__content__slider";
  const indicatorContainer =
    document.querySelector<HTMLElement>(".swiper__indicator");
  const progressBar = indicatorContainer?.querySelector<HTMLElement>(
    ".swiper__indicator__progress"
  );

  if (
    document.querySelector(sliderSelector) &&
    indicatorContainer &&
    progressBar
  ) {
    const swiper = new Swiper(sliderSelector, {
      modules: [Navigation],
      slidesPerView: 1.128,
      spaceBetween: 20,
      loop: false,
      speed: 600,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
      },
      on: {
        init(swiperInstance: any) {
          updateIndicatorProgress(
            swiperInstance,
            indicatorContainer,
            progressBar
          );
        },
        slideChange(swiperInstance: any) {
          updateIndicatorProgress(
            swiperInstance,
            indicatorContainer,
            progressBar
          );
        },
      },
    });

    indicatorContainer.addEventListener("click", (e: MouseEvent) => {
      const rect = indicatorContainer.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percent = x / rect.width;
      const slidesCount = swiper.slides.length;
      const slidesPerView = typeof swiper.params.slidesPerView === 'number' ? swiper.params.slidesPerView : 1;
      const steps = slidesCount - slidesPerView + 1;
      const slideTo = Math.floor(percent * steps);
      swiper.slideTo(slideTo);
    });
  }

  // --- POPULAR SWIPER ---
  const popularSelector = ".popular-swiper";
  const popularIndicator = document.querySelector<HTMLElement>(
    "#popular .swiper__indicator"
  );
  const popularProgress = popularIndicator?.querySelector<HTMLElement>(
    ".swiper__indicator__progress"
  );
  const popularPrev = document.querySelector<HTMLElement>(
    ".popular__header__slider-controls__prev"
  );
  const popularNext = document.querySelector<HTMLElement>(
    ".popular__header__slider-controls__next"
  );
  const popularControls = document.querySelector<HTMLElement>(
    ".popular__header__slider-controls"
  );

  if (
    document.querySelector(popularSelector) &&
    popularIndicator &&
    popularProgress &&
    popularPrev &&
    popularNext
  ) {
    const swiperPopular = new Swiper(popularSelector, {
      modules: [Navigation],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        prevEl: popularPrev,
        nextEl: popularNext,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      speed: 600,
      on: {
        init(swiperInstance: any) {
          updateIndicatorProgress(
            swiperInstance,
            popularIndicator,
            popularProgress
          );
          toggleSliderControls(
            swiperInstance,
            popularControls,
            popularIndicator
          );
        },
        slideChange(swiperInstance: any) {
          updateIndicatorProgress(
            swiperInstance,
            popularIndicator,
            popularProgress
          );
        },
        breakpoint(swiperInstance: any) {
          // Вызывается при изменении breakpoint (изменение размера экрана)
          toggleSliderControls(
            swiperInstance,
            popularControls,
            popularIndicator
          );
        },
        resize(swiperInstance: any) {
          // Дополнительно вызываем при изменении размера окна
          toggleSliderControls(
            swiperInstance,
            popularControls,
            popularIndicator
          );
        },
      },
    });

    popularIndicator.addEventListener("click", (e: MouseEvent) => {
      const rect = popularIndicator.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const percent = x / rect.width;
      const slidesCount = swiperPopular.slides.length;
      const slidesPerView = typeof swiperPopular.params.slidesPerView === 'number' ? swiperPopular.params.slidesPerView : 1;
      const steps = slidesCount - slidesPerView + 1;
      const slideTo = Math.floor(percent * steps);
      swiperPopular.slideTo(slideTo);
    });
  }

  // --- SPECIAL TEACHERS SWIPERS ---
  // Исключаем docs-swiper из tooltip'ов, ищем только прямые дочерние swiper'ы
  const specialSwipers = document.querySelectorAll<HTMLElement>('.teacher__special-swiper > .swiper');
  

  
  // Добавляем небольшую задержку для того чтобы DOM был полностью готов
  setTimeout(() => {
    specialSwipers.forEach((swiperElement, index) => {
      const container = swiperElement.closest('.teacher__special-swiper') as HTMLElement;
      if (!container) {

        return;
      }
      
      // Дополнительная диагностика - проверяем слайды в DOM
      const slidesInDOM = swiperElement.querySelectorAll('.swiper-slide');

      
      const prevButton = container.querySelector<HTMLElement>('.special-card-prev');
      const nextButton = container.querySelector<HTMLElement>('.special-card-next');
      const pagination = container.querySelector<HTMLElement>('.special-pagination');
      // Ищем как special-controls, так и swiper-controls для совместимости
      const controls = container.querySelector<HTMLElement>('.special-controls') || 
                      container.querySelector<HTMLElement>('.swiper-controls');
      

      
      if (prevButton && nextButton && pagination) {
        const specialSwiper = new Swiper(swiperElement, {
          modules: [Navigation, Pagination],
          loop: false,
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
          pagination: {
            el: pagination,
            clickable: true,
          },
          speed: 600,
          on: {
            init(swiperInstance: any) {
              // Скрыть/показать элементы управления для этого конкретного свайпера
              const slidesCount = swiperInstance.slides.length;
              const realSlidesCount = swiperElement.querySelectorAll('.swiper-slide').length;
              

              
              // Используем реальное количество слайдов из DOM, если swiper их не видит
              const actualSlidesCount = slidesCount > 0 ? slidesCount : realSlidesCount;
              
              if (actualSlidesCount <= 1) {
                if (controls) {
                  controls.style.display = 'none';

                }
                if (pagination) {
                  pagination.style.display = 'none';

                }
              } else {
                if (controls) {
                  controls.style.display = '';

                }
                if (pagination) {
                  pagination.style.display = '';

                }
              }
            },
            slidesUpdated(swiperInstance: any) {
              // Вызывается когда слайды обновляются
              const slidesCount = swiperInstance.slides.length;

              
              if (slidesCount <= 1) {
                if (controls) controls.style.display = 'none';
                if (pagination) pagination.style.display = 'none';
              } else {
                if (controls) controls.style.display = '';
                if (pagination) pagination.style.display = '';
              }
            },
          },
        });
      } else {

      }
    });
  }, 100); // Задержка 100ms

  // Здесь можно добавить инициализацию других свайперов по аналогии
}

// Универсальная функция обновления прогресс-бара
function updateIndicatorProgress(
  swiperInstance: any,
  indicatorContainer: HTMLElement,
  progressBar: HTMLElement
) {
  const slidesCount = swiperInstance.slides.length;
  const steps = slidesCount - swiperInstance.params.slidesPerView + 1;
  let current = swiperInstance.activeIndex;
  if (current > steps - 1) current = steps - 1;
  const stepWidth = 100 / steps;
  progressBar.style.width = stepWidth + "%";
  // Нужно дождаться применения ширины, чтобы корректно получить offsetWidth
  setTimeout(() => {
    const containerWidth = indicatorContainer.offsetWidth;
    const barWidth = progressBar.offsetWidth;
    const maxOffset = containerWidth - barWidth;
    const offset = steps > 1 ? maxOffset * (current / (steps - 1)) : 0;
    progressBar.style.transform = `translateX(${offset}px)`;
  }, 0);
}

// Функция для скрытия/показа элементов управления слайдером
function toggleSliderControls(
  swiperInstance: any,
  controlsElement: HTMLElement | null,
  indicatorElement: HTMLElement | null
): void {/*
  if (!controlsElement || !indicatorElement) return;

  const slidesCount = swiperInstance.slides.length;
  const slidesPerView = swiperInstance.params.slidesPerView;

  // Если слайдов меньше или равно slidesPerView, скрываем элементы управления
  if (slidesCount <= slidesPerView) {
    controlsElement.style.display = "none";
    indicatorElement.style.display = "none";
  } else {
    controlsElement.style.display = "";
    indicatorElement.style.display = "";
  }
*/}
